import {css} from "@panda/css";

import {LeadModal} from "../../../application/components/LeadModal";
import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import {PricesHubArticles} from "../components/prices_hub/PricesHubArticles";
import {PricesHubDataSources} from "../components/prices_hub/PricesHubDataSources";
import {PricesHubFaq} from "../components/prices_hub/PricesHubFaq";
import {PricesHubHero} from "../components/prices_hub/PricesHubHero";
import {PricesHubLinks} from "../components/prices_hub/PricesHubLinks";
import {PricesHubOffers} from "../components/prices_hub/PricesHubOffers";
import {PricesHubShorts} from "../components/prices_hub/PricesHubShorts";
import {PricesHubTransactionPrices} from "../components/prices_hub/PricesHubTransactionPrices";
import {PricesViewType} from "../helpers/prices_view_type";

export const PricesFlatsGeneralView = () => {
    return (
        <div className={viewStyle}>
            <PricesBreadcrumbs type={PricesViewType.FLATS} className={breadcrumbsStyle} />

            <PricesHubHero />

            <div className={contentStyle}>
                <PricesHubTransactionPrices />

                <PricesHubDataSources />

                <PricesHubShorts />

                <PricesHubFaq />

                <PricesHubOffers />

                <PricesHubArticles />

                <PricesHubLinks />
            </div>

            <LeadModal />
        </div>
    );
};

const viewStyle = css({
    minWidth: 0,
    backgroundColor: "var(--colors-gray-100)"
});

const breadcrumbsStyle = css({
    py: 1
});

const contentStyle = css({
    marginTop: 3,

    md: {
        marginTop: 6
    }
});
import {css} from "@panda/css";

import {LeadModal} from "../../../application/components/LeadModal";
import {PricesBreadcrumbs} from "../atoms/PricesBreadcrumbs";
import {PricesHubArticles} from "../components/prices_hub/PricesHubArticles";
import {PricesHubDataSources} from "../components/prices_hub/PricesHubDataSources";
import {PricesHubFaq} from "../components/prices_hub/PricesHubFaq";
import {PricesHubHero} from "../components/prices_hub/PricesHubHero";
import {PricesHubLinks} from "../components/prices_hub/PricesHubLinks";
import {PricesHubOffers} from "../components/prices_hub/PricesHubOffers";
import {PricesHubShorts} from "../components/prices_hub/PricesHubShorts";
import {PricesHubTransactionPrices} from "../components/prices_hub/PricesHubTransactionPrices";
import {PricesViewType} from "../helpers/prices_view_type";

export const PricesFlatsGeneralView = () => {
    return (
        <div className={viewStyle}>
            <PricesBreadcrumbs type={PricesViewType.FLATS} className={breadcrumbsStyle} />

            <PricesHubHero />

            <div className={contentStyle}>
                <PricesHubTransactionPrices />

                <PricesHubDataSources />

                <PricesHubShorts />

                <PricesHubFaq />

                <PricesHubOffers />

                <PricesHubArticles />

                <PricesHubLinks />
            </div>

            <LeadModal />
        </div>
    );
};

const viewStyle = css({
    minWidth: 0,
    backgroundColor: "var(--colors-gray-100)"
});

const breadcrumbsStyle = css({
    py: 1
});

const contentStyle = css({
    marginTop: 3,

    md: {
        marginTop: 6
    }
});
